import React from 'react';
import { string, func, bool, array } from 'prop-types';
import { get } from 'lodash';
import { Text, Button, FormInput, Icon } from '../../../common';
import {
    OrderSection,
    SectionCard,
    PinContainer,
    PinInputWrapper,
    PinButtonWrapper,
    ErrorAlert,
    ErrorContent,
    ErrorTitle,
    ErrorMessage
} from '../styles';
import PendingOrders from './PendingOrders';

const PinSection = ({
    storeName,
    pin,
    onChange,
    onValidate,
    loading,
    error,
    pendingOrders,
    loadingProducts,
    onOrderEyeClick,
    onErrorClose
}) => {
    return (
        <OrderSection>
            <SectionCard>
                {/* Store Name */}
                {storeName && (
                    <div style={{ marginBottom: 20 }}>
                        <Text text={storeName.toUpperCase()} strong size={24} />
                    </div>
                )}

                {/* PIN Input Section */}
                <PinContainer>
                    <PinInputWrapper>
                        <FormInput
                            label='PIN'
                            placeholder='Ingrese el pin de registro'
                            value={pin}
                            onChange={({ target }) => onChange(get(target, 'value', '').toUpperCase())}
                            style={{ margin: 0 }}
                        />
                    </PinInputWrapper>
                    <PinButtonWrapper>
                        <Button
                            backgroundColor='#1FA02E'
                            text='Ver pedido'
                            action='action_name'
                            onClick={onValidate}
                            disabled={!pin || loading}
                            style={{ height: 34, minWidth: 200, border: 0 }}
                        />
                    </PinButtonWrapper>
                </PinContainer>

                {/* Error Message */}

                {error && (
                    <div style={{ marginBottom: 20 }}>
                        <ErrorAlert>
                            <Icon name='alert-circle' size={28} color='#BD2C00' />
                            <ErrorContent>
                                <ErrorTitle>PIN inválido</ErrorTitle>
                                <ErrorMessage>{error}</ErrorMessage>
                            </ErrorContent>
                            {onErrorClose && (
                                <Icon
                                    name='close'
                                    size={20}
                                    color='#BD2C00'
                                    style={{ cursor: 'pointer', marginLeft: 'auto', alignSelf: 'flex-start' }}
                                    onClick={onErrorClose}
                                />
                            )}
                        </ErrorAlert>
                    </div>
                )}
                {/* Tabla de pedidos pendientes */}
                {!loadingProducts && pendingOrders && pendingOrders.length > 0 && (
                    <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 5 }}>
                        <Text text='Pedidos pendientes: ' size={14} />
                        <Text text={`${pendingOrders.length}`} size={14} strong />
                    </div>
                )}

                <PendingOrders
                    orders={pendingOrders}
                    loading={loadingProducts}
                    onEyeClick={onOrderEyeClick}
                />
            </SectionCard>
        </OrderSection>
    );
};

PinSection.propTypes = {
    storeName: string,
    pin: string,
    onChange: func.isRequired,
    onValidate: func.isRequired,
    loading: bool,
    error: string,
    pendingOrders: array,
    loadingProducts: bool,
    onOrderEyeClick: func,
    onErrorClose: func
};

PinSection.defaultProps = {
    storeName: '',
    pin: '',
    loading: false,
    error: null,
    pendingOrders: [],
    loadingProducts: false,
    onOrderEyeClick: null,
    onErrorClose: null
};

export default PinSection;
